export default "__VITE_ASSET__DUP6yxC5__"